
  <mb-dialog-header>
    <h3
      class="mb-dialog-custom__header text"
      i18n="
        @@modals_disneyclusterticketsinfo_suma_tus_tickets_y_obtene_grandes_beneficios"
    >
      Sumá tus tickets y obtené grandes beneficios
    </h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <h6
        i18n="
          @@modals_disneyclusterticketsinfo_cuantos_dias_vas_a_disfrutar_de_los_parques"
      >
        ¿Cúantos días vas a disfrutar de los parques?
      </h6>
      <h6
        class="title"
        i18n="@@modals_disneyclusterticketsinfo_los_tickets_son_para_todos_los_pasajeros"
      >
        Los tickets son para todos los pasajeros
      </h6>
      <div
        class="ticket-select close"
        (click)="showTicketSelector = !showTicketSelector"
        *ngIf="!showTicketSelector"
      >
        <mb-icon class="icon icon-arrow-down" icon="arrow-down"></mb-icon>
        <div
          class="empty-ticket"
          *ngIf="!selectedTicketDays"
          i18n="@@modals_disneyclusterticketsinfo_selecciona_el_numero_de_dias"
        >
          Seleccioná el número de días
        </div>
        <div class="selected-ticket" *ngIf="selectedTicketDays">
          <p class="days" i18n="@@modals_disneyclusterticketsinfo_x_dias">
            {{ selectedTicketDays.days }} días
          </p>
          <p>
            <span i18n="@@modals_disneyclusterticketsinfo_desde">Desde </span>
            <strong>$ {{ selectedTicketDays.price }}</strong>
          </p>
          <span
            i18n="@@modals_disneyclusterticketsinfo_dos_dias_gratis"
            class="offer"
            *ngIf="
              selectedTicketDays.offer === 'GRATIS' && !hasPromo(selectedTicketDays.days)
            "
            >¡Dos días gratis!</span
          >
          <span
            i18n="@@modals_disneyclusterticketsinfo_oferta_especial"
            class="offer"
            *ngIf="
              selectedTicketDays.offer === 'OFERTA_ESPECIAL' &&
              !hasPromo(selectedTicketDays.days)
            "
            >¡Oferta especial!</span
          >
          <span
            i18n="@@modals_disneyclusterticketsinfo_plan_de_comida_mas_2_dias_gratis"
            class="offer"
            *ngIf="
              selectedTicketDays.offer === 'GRATIS' && hasPromo(selectedTicketDays.days)
            "
            >¡Plan de comidas + dos días gratis!</span
          >
          <span
            i18n="@@modals_disneyclusterticketsinfo_plan_de_comida_mas_oferta_especial"
            class="offer"
            *ngIf="
              selectedTicketDays.offer === 'OFERTA_ESPECIAL' &&
              hasPromo(selectedTicketDays.days)
            "
            >¡Plan de comidas + oferta especial!</span
          >
          <span
            i18n="@@modals_disneyclusterticketsinfo_plan_de_comidas_gratis"
            class="offer"
            *ngIf="selectedTicketDays.offer === '' && hasPromo(selectedTicketDays.days)"
            >¡Plan de comidas gratis!</span
          >
        </div>
      </div>
      <div class="ticket-select open" *ngIf="showTicketSelector">
        <mb-icon class="icon icon-arrow-up" icon="arrow-up"></mb-icon>
        <div
          i18n="@@modals_disneyclusterticketsinfo_selecciona_el_numero_de_dias"
          class="empty-ticket"
        >
          Seleccioná el número de días
        </div>
        <label
          *ngFor="let ticket of tickets; let i = index"
          (click)="toggleTicketSelector(i + 1, ticket.days)"
        >
          <span class="days" i18n="@@modals_disneyclusterticketsinfo_x_dias"
            >{{ ticket.days }} días</span
          >
          <span
            ><span i18n="@@modals_disneyclusterticketsinfo_desde">Desde </span
            ><strong>$ {{ ticket.price }}</strong></span
          >
          <span
            i18n="@@modals_disneyclusterticketsinfo_dos_dias_gratis"
            class="offer"
            *ngIf="ticket.offer === 'GRATIS' && !hasPromo(ticket.days)"
            >¡Dos días gratis!</span
          >
          <span
            i18n="@@modals_disneyclusterticketsinfo_oferta_especial"
            class="offer"
            *ngIf="ticket.offer === 'OFERTA_ESPECIAL' && !hasPromo(ticket.days)"
            >¡Oferta especial!</span
          >
          <span
            i18n="@@modals_disneyclusterticketsinfo_plan_de_comida_mas_2_dias_gratis"
            class="offer"
            *ngIf="ticket.offer === 'GRATIS' && hasPromo(ticket.days)"
            >¡Plan de comidas + dos días gratis!</span
          >
          <span
            i18n="@@modals_disneyclusterticketsinfo_plan_de_comida_mas_oferta_especial"
            class="offer"
            *ngIf="ticket.offer === 'OFERTA_ESPECIAL' && hasPromo(ticket.days)"
            >¡Plan de comidas + oferta especial!</span
          >
          <span
            i18n="@@modals_disneyclusterticketsinfo_plan_de_comidas_gratis"
            class="offer"
            *ngIf="ticket.offer === '' && hasPromo(ticket.days)"
            >¡Plan de comidas gratis!</span
          >
        </label>
      </div>
      <div *ngIf="this.supplements[ticketDays]">
        <section *ngFor="let supplements of this.supplements[ticketDays] | keyvalue">
          <div class="ticket_{{ supplements.key | lowercase }}">
            <div class="ticket-header-park">
              <div
                i18n="
                  @@modals_disneyclusterticketsinfo_disfruta_mucha_mas_diversion_con_estas_opciones"
                class="left"
              >
                Disfrutá mucha mas diversión con estas opciones
              </div>
              <div
                i18n="
                  @@modals_disneyclusterticketsinfo_visita_varios_parques_en_el_mismo_dia"
                class="right"
              >
                Visitá varios parques en el mismo día
              </div>
            </div>
            <div class="ticket-header">
              <div i18n="@@modals_disneyclusterticketsinfo_tipo_de_tickets" class="left">
                Tipo de Tickets
              </div>
              <div class="right">
                <span
                  i18n="
                    @@modals_disneyclusterticketsinfo_ingresando_el_dia_del_check_in_del_hotel"
                  >Ingresando el día del Check in del hotel</span
                >
              </div>
              <div class="right">
                <span
                  i18n="
                    @@modals_disneyclusterticketsinfo_ingresando_cualquier_dia_de_la_estadia"
                  >Ingresando cualquier día de la estadía</span
                >
              </div>
            </div>
            <div class="ticket-content">
              <div class="ticket-description">
                <div *ngIf="supplements.key === 'BASICO'">
                  <div
                    i18n="@@modals_disneyclusterticketsinfo_un_parque_por_dia"
                    class="title"
                  >
                    Un parque por día
                  </div>
                  <p
                    i18n="
                      @@modals_disneyclusterticketsinfo_accede_a_1_de_los_4_parques_tematicos_principales_por_dia_podes_elegir_entre_los_cuatro_parques_tematicos_de_walt_disney_world_resort"
                  >
                    <span
                      >Accedé a 1 de los 4 parques temáticos principales por día.</span
                    >
                    Podés elegir entre los cuatro Parques Temáticos de Walt Disney World
                    Resort.
                  </p>
                </div>
                <div *ngIf="supplements.key === 'BASICO_PLUS'">
                  <div class="title">
                    <span
                      i18n="@@modals_disneyclusterticketsinfo_un_parque_por_dia"
                      class="title"
                      >Un parque por día</span
                    >
                    <span
                      i18n="@@modals_disneyclusterticketsinfo_incluye_parques_acuaticos"
                      class="offer"
                      >¡Incluye Parques Acuáticos!</span
                    >
                  </div>
                  <p
                    i18n="
                      @@modals_disneyclusterticketsinfo_por_cada_dia_de_pase_contratado_sumas_una_visita_a_los_parques_acuaticos_y_atracciones_de_golf"
                  >
                    Por cada día de pase contratado, sumás una visita a los
                    <strong>parques acuáticos y atracciones de golf.</strong>
                  </p>
                </div>
                <div *ngIf="supplements.key === 'PARK_HOPPER'">
                  <div class="title">Park Hopper</div>
                  <p
                    i18n="
                      @@modals_disneyclusterticketsinfo_visita_mas_de_un_parque_por_dia_podes_recorrer_mas_de_un_parque_por_dia_o_visitar_uno_a_la_manana_y_otro_a_la_tarde_elegi_entre_los_cuatro_parques_tematicos_de_walt_disney_world_resort"
                  >
                    <span>¡Visitá más de un parque por día!</span> Podes recorrer más de
                    un parque por día o visitar uno a la mañana y otro a la tarde.<br />
                    Elegí entre los cuatro Parques Temáticos de Walt Disney World Resort.
                  </p>
                </div>
                <div *ngIf="supplements.key === 'PARK_HOPPER_PLUS'">
                  <div class="title">
                    Park Hopper Plus
                    <span
                      i18n="@@modals_disneyclusterticketsinfo_incluye_parques_acuaticos"
                      class="offer"
                      >¡Incluye Parques Acuáticos!</span
                    >
                  </div>
                  <p
                    i18n="
                      @@modals_disneyclusterticketsinfo_te_permite_visitar_mas_de_un_parque_por_dia_y_ademas_tenes_visitas_extra_ademas_de_los_4_parques_incluidos_en_la_opcion_park_hopper_por_cada_dia_de_pase_contratado_sumas_una_visita_a_los_parques_acuaticos_y_atracciones_de_golf"
                  >
                    <span
                      >Te permite visitar más de un parque por día y además, tenés visitas
                      extra!</span
                    >
                    Además de los 4 parques incluidos en la Opción Park Hopper, por cada
                    día de pase contratado, sumás una visita a los
                    <strong>parques acuáticos y atracciones de golf.</strong>
                  </p>
                </div>
                <div class="parks">
                  <div
                    i18n="@@modals_disneyclusterticketsinfo_parques_principales"
                    class="title"
                  >
                    Parques principales
                  </div>
                  <ul>
                    <li>Magic Kingdom Park</li>
                    <li>Epcot</li>
                    <li>Disney’s Hollywood Studios</li>
                    <li>Disney’s Animal Kingdom Theme Park</li>
                  </ul>
                </div>
                <div
                  *ngIf="
                    supplements.key === 'PARK_HOPPER_PLUS' ||
                    supplements.key === 'BASICO_PLUS'
                  "
                  class="extras"
                >
                  <div
                    i18n="@@modals_disneyclusterticketsinfo_visitas_extra"
                    class="title"
                  >
                    ¡Visitas extra!
                  </div>
                  <ul>
                    <li>Disney's Blizzard Beach</li>
                    <li>Disney's Typhoon Lagoon</li>
                    <li>Disney's Oak Trail Golf Course</li>
                    <li>Complejo ESPN Wide World of Sports</li>
                    <li>Disney's Fantasia Gardens Miniature Golf Course</li>
                    <li>Disney's Winter Summerland Miniature Golf Course</li>
                  </ul>
                </div>
              </div>
              <div class="ticket-price flexible">
                <mb-advice
                  align="left"
                  *ngIf="supplements.value.no_flexible?.discount.percentage"
                  class="gift"
                >
                  {{
                    supplements.value.no_flexible.discount.percentage | number: '1.0-0'
                  }}% OFF
                </mb-advice>
                <div>
                  <p
                    class="discount"
                    *ngIf="supplements.value.no_flexible?.discount.percentage"
                  >
                    <span>$&nbsp;</span>
                    <strong>{{
                      supplements.value.no_flexible.discount.amount | Currency
                    }}</strong>
                  </p>
                  <div
                    class="price"
                    [ngClass]="{ 'no-ticket': !supplements.value.no_flexible }"
                  >
                    <strong *ngIf="supplements.value.no_flexible"
                      >$ {{ supplements.value.no_flexible.amount | Currency }}</strong
                    >
                    <strong
                      *ngIf="!supplements.value.no_flexible"
                      i18n="@@modals_disneyclusterticketsinfo_ticket_no_disponible"
                      >Ticket no disponible</strong
                    >
                  </div>
                  <button
                    *ngIf="supplements.value.no_flexible"
                    mb-button
                    mb-button-fullwidth
                    variant="principal"
                    color="primary"
                    i18n="@@modals_disneyclusterticketsinfo_sumar_ticket"
                    (click)="selectTicket(supplements.value.no_flexible)"
                  >
                    Sumar ticket
                  </button>
                  <button
                    *ngIf="!supplements.value.no_flexible"
                    mb-button
                    mb-button-fullwidth
                    variant="principal"
                    color="primary"
                    [disabled]="true"
                    i18n="@@no_disponible"
                  >
                    No disponible
                  </button>
                  <div
                    i18n="@@modals_disneyclusterticketsinfo_plan_de_comidas_gratis"
                    class="offer"
                    *ngIf="
                      supplements.value.no_flexible &&
                      isMealPlanFree(supplements.value.no_flexible)
                    "
                  >
                    ¡Plan de comidas gratis!
                  </div>
                  <div
                    i18n="@@modals_disneyclusterticketsinfo_dos_dias_gratis"
                    class="offer"
                    *ngIf="supplements.value.no_flexible?.offer === 'GRATIS'"
                  >
                    ¡Dos días gratis!
                  </div>
                  <div
                    i18n="@@modals_disneyclusterticketsinfo_oferta_especial"
                    class="offer"
                    *ngIf="supplements.value.no_flexible?.offer === 'OFERTA_ESPECIAL'"
                  >
                    ¡Oferta especial!
                  </div>
                </div>
              </div>
              <div class="ticket-price flexible">
                <div>
                  <div
                    class="price"
                    [ngClass]="{ 'no-ticket': !supplements.value.flexible }"
                  >
                    <strong *ngIf="supplements.value.flexible"
                      >$ {{ supplements.value.flexible.amount | Currency }}</strong
                    >
                    <strong
                      *ngIf="!supplements.value.flexible"
                      i18n="@@modals_disneyclusterticketsinfo_ticket_no_disponible"
                      >Ticket no disponible</strong
                    >
                  </div>
                  <button
                    *ngIf="supplements.value.flexible"
                    mb-button
                    mb-button-fullwidth
                    variant="principal"
                    color="primary"
                    i18n="@@modals_disneyclusterticketsinfo_sumar_ticket"
                    (click)="selectTicket(supplements.value.flexible)"
                  >
                    Sumar ticket
                  </button>
                  <button
                    *ngIf="!supplements.value.flexible"
                    mb-button
                    mb-button-fullwidth
                    variant="principal"
                    color="primary"
                    [disabled]="true"
                    i18n="@@no_disponible"
                  >
                    No disponible
                  </button>
                  <div
                    i18n="@@modals_disneyclusterticketsinfo_plan_de_comidas_gratis"
                    class="offer"
                    *ngIf="
                      supplements.value.flexible &&
                      isMealPlanFree(supplements.value.flexible)
                    "
                  >
                    ¡Plan de comidas gratis!
                  </div>
                  <div
                    i18n="@@modals_disneyclusterticketsinfo_dos_dias_gratis"
                    class="offer"
                    *ngIf="supplements.value.flexible?.offer === 'GRATIS'"
                  >
                    ¡Dos días gratis!
                  </div>
                  <div
                    i18n="@@modals_disneyclusterticketsinfo_oferta_especial"
                    class="offer"
                    *ngIf="supplements.value.flexible?.offer === 'OFERTA_ESPECIAL'"
                  >
                    ¡Oferta especial!
                  </div>
                </div>
              </div>
              <div class="ticket-price-mobile">
                <div class="swipe">
                  <div class="ticket-price">
                    <div class="left-discount">
                      <mb-advice
                        align="left"
                        *ngIf="supplements.value.no_flexible?.discount.percentage"
                        class="gift"
                      >
                        {{
                          supplements.value.no_flexible.discount.percentage
                            | number: '1.0-0'
                        }}% OFF
                      </mb-advice>
                      <div class="title get-down">
                        <span
                          i18n="
                            @@modals_disneyclusterticketsinfo_ingresando_el_dia_del_check_in_del_hotel"
                          >Ingresando el día del Check in del hotel</span
                        >
                      </div>
                    </div>
                    <div class="price-box">
                      <div class="left">
                        <p
                          class="discount"
                          *ngIf="supplements.value.no_flexible?.discount.percentage"
                        >
                          <span>$&nbsp;</span>
                          <strong>{{
                            supplements.value.no_flexible.discount.amount | Currency
                          }}</strong>
                        </p>
                        <div
                          class="price"
                          [ngClass]="{ 'no-ticket': !supplements.value.no_flexible }"
                        >
                          <strong *ngIf="supplements.value.no_flexible"
                            >$
                            {{ supplements.value.no_flexible.amount | Currency }}</strong
                          >
                          <strong
                            *ngIf="!supplements.value.no_flexible"
                            i18n="@@modals_disneyclusterticketsinfo_ticket_no_disponible"
                            >Ticket no disponible</strong
                          >
                        </div>
                      </div>
                      <div class="right">
                        <button
                          *ngIf="supplements.value.no_flexible"
                          mb-button
                          mb-button-fullwidth
                          type="principal"
                          color="primary"
                          i18n="@@modals_disneyclusterticketsinfo_sumar_ticket"
                          (click)="selectTicket(supplements.value.no_flexible)"
                        >
                          Sumar ticket
                        </button>
                        <button
                          *ngIf="!supplements.value.no_flexible"
                          mb-button
                          mb-button-fullwidth
                          type="principal"
                          color="primary"
                          [disabled]="true"
                          i18n="@@no_disponible"
                        >
                          No disponible
                        </button>
                        <div
                          i18n="@@modals_disneyclusterticketsinfo_plan_de_comidas_gratis"
                          class="offer"
                          *ngIf="
                            supplements.value.no_flexible &&
                            isMealPlanFree(supplements.value.no_flexible)
                          "
                        >
                          ¡Plan de comidas gratis!
                        </div>
                        <div
                          i18n="@@modals_disneyclusterticketsinfo_dos_dias_gratis"
                          class="offer"
                          *ngIf="supplements.value.no_flexible?.offer === 'GRATIS'"
                        >
                          ¡Dos días gratis!
                        </div>
                        <div
                          i18n="@@modals_disneyclusterticketsinfo_oferta_especial"
                          class="offer"
                          *ngIf="
                            supplements.value.no_flexible?.offer === 'OFERTA_ESPECIAL'
                          "
                        >
                          ¡Oferta especial!
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ticket-price">
                    <div class="title get-down">
                      <span
                        i18n="
                          @@modals_disneyclusterticketsinfo_ingresando_cualquier_dia_de_la_estadia"
                        >Ingresando cualquier día de la estadía</span
                      >
                    </div>
                    <div class="price-box">
                      <div class="left">
                        <div
                          class="price flexible"
                          [ngClass]="{ 'no-ticket': !supplements.value.flexible }"
                        >
                          <strong *ngIf="supplements.value.flexible"
                            >$ {{ supplements.value.flexible.amount | Currency }}</strong
                          >
                          <strong
                            *ngIf="!supplements.value.flexible"
                            i18n="@@modals_disneyclusterticketsinfo_ticket_no_disponible"
                            >Ticket no disponible</strong
                          >
                        </div>
                      </div>
                      <div class="right">
                        <button
                          *ngIf="supplements.value.flexible"
                          mb-button
                          mb-button-fullwidth
                          variant="principal"
                          color="primary"
                          i18n="@@modals_disneyclusterticketsinfo_sumar_ticket"
                          (click)="selectTicket(supplements.value.flexible)"
                        >
                          Sumar ticket
                        </button>
                        <button
                          *ngIf="!supplements.value.flexible"
                          mb-button
                          mb-button-fullwidth
                          variant="principal"
                          color="primary"
                          [disabled]="true"
                          i18n="@@no_disponible"
                        >
                          No disponible
                        </button>
                        <div
                          i18n="@@modals_disneyclusterticketsinfo_plan_de_comidas_gratis"
                          class="offer"
                          *ngIf="
                            supplements.value.flexible &&
                            isMealPlanFree(supplements.value.flexible)
                          "
                        >
                          ¡Plan de comidas gratis!
                        </div>
                        <div
                          i18n="@@modals_disneyclusterticketsinfo_dos_dias_gratis"
                          class="offer"
                          *ngIf="supplements.value.flexible?.offer === 'GRATIS'"
                        >
                          ¡Dos días gratis!
                        </div>
                        <div
                          i18n="@@modals_disneyclusterticketsinfo_oferta_especial"
                          class="offer"
                          *ngIf="supplements.value.flexible?.offer === 'OFERTA_ESPECIAL'"
                        >
                          ¡Oferta especial!
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </mb-dialog-body>
